<template>
   <DxPopup :visible="open" :ref="refPopup" title="Activación de tomos" :drag-enabled="true" :hide-on-outside-click="false"
    :show-close-button="false" @hidden="onHidden" :show-title="true" :width="300" :height="250" :shading="false">
    <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="importButtonOptions" />
    <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="closeButtonOptions" />
    <div>
      <p>Ingrese el código de activación o Key:</p>
      <DxTextBox v-model:value="key"/>
    </div>
  </DxPopup>
</template>
<script>
/* eslint-disable */
import 'devextreme/dist/css/dx.common.css';
import '../../themes/generated/theme.base.css';
import '../../themes/generated/theme.additional.css';
import DxPopup, { DxToolbarItem } from "devextreme-vue/popup";
import DxTextBox from 'devextreme-vue/text-box';
import notify from 'devextreme/ui/notify';
const refPopup = "modal-active-volumen";
var ui = require("../../plugins/busyUi").default;
import http from "../../api/http";
import {
    confirm
} from "devextreme/ui/dialog";
var _this = null
export default {
  name: "component-active-vol",
  components: {
    DxPopup,
    DxToolbarItem,
    DxTextBox
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      refPopup,
      importButtonOptions: {
        text: 'Activar',
        onClick: () => {
          if(_this.key==""){
            notify({
                  message: "El campo de la licencia no puede estar vacio",
                  width: 'auto',
                  shading: false,
                  position: "top center"
              },
              "info",
              900
            );
            return false;
          }
          let result = confirm("Esta seguro que desea activar esta llave?", "Confirmar activación");
          result.then((dialogResult) => {
                if(!dialogResult) return false;
                ui.busyUi(true, $(_this.Popup._$element[0]));
                http.post("active_key",{key:_this.key})
                .then((response) => {
                    if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                      notify({
                              message: "Se activó la llave correctamente",
                              width: 'auto',
                              shading: false,
                              position: "center"
                          },
                          "success",
                          900
                      );
                    } else {
                      notify({
                              message: response.DATA,
                              width: 'auto',
                              shading: false,
                              position: "top center"
                          },
                          "info",
                          900
                      );
                    }
                    ui.busyUi(false, $(_this.Popup._$element[0]));
                })
                .catch((error) => {
                  ui.busyUi(false, $(_this.Popup._$element[0]));
                    console.error(error);
                });
            });
        },
      },
      key:"",
      closeButtonOptions: {
        text: 'Cancelar',
        onClick: () => {
          _this.Popup.option('visible', false);
        }
      }
    };
  },
  methods: {
    onHidden() {
      _this.Popup.option('visible', false);
      this.$store.commit('SetModalActiveVolumen');
    },
  },
  beforeDestroy() {
    this.$refs['modal-active-volumen'].instance.option('visible', false);
    this.$refs['modal-active-volumen'].instance.dispose();
  },
  mounted() {
    _this = this
    this.Popup = this.$refs[refPopup] && this.$refs[refPopup].instance;
  }
};
</script>